import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

function UserActivityChart() {
  const data = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      { label: 'Sessions', data: [120, 150, 180, 170, 220, 240, 260], borderColor: '#4c84ff', backgroundColor: 'rgba(76,132,255,0.2)', tension: 0.4, fill: true },
      { label: 'Signups', data: [40, 50, 60, 55, 70, 80, 85], borderColor: '#80e1c1', backgroundColor: 'rgba(128,225,193,0.2)', tension: 0.4, fill: true },
    ],
  };
  const options = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: true } }, scales: { y: { beginAtZero: true } } };
  return (
    <div style={{ height: 260 }}>
      <Line data={data} options={options} />
    </div>
  );
}

export default UserActivityChart;


